import { useQuery } from 'react-query';
import { AxiosError } from 'axios';
import api from 'services';
import { ApiError } from 'services/api.errors';
import { PortfolioAssetsType } from 'services/requests';
import { CommonCustomError } from 'types/errors';
import { QueryKeys } from 'constants/queryKeys';
import { useGetAllAssets } from './useGetAllAssets';

export const useGetEtzProfileAssets = () => {
  const { isSuccess, data: allAssets } = useGetAllAssets();

  const queryFn = () => async (): Promise<PortfolioAssetsType> => {
    if (!allAssets) {
      throw new CommonCustomError();
    }

    const { data } = await api.getEtzProfileAssets();

    const baseAsset = allAssets[data.baseAsset.id];
    if (!baseAsset) {
      throw new CommonCustomError();
    }

    const items = data.items.map((dataItem) => {
      const assetInfo = allAssets[dataItem.asset.id];
      if (!assetInfo) {
        throw new CommonCustomError();
      }
      return { ...dataItem, asset: assetInfo };
    });

    return {
      baseAsset,
      items,
    };
  };

  const queryKey = QueryKeys.etzProfileAssets;

  return useQuery<PortfolioAssetsType, AxiosError<ApiError>>(queryKey, queryFn(), {
    enabled: isSuccess,
    retry: 1,
  });
};
